module.exports = __webpack_public_path__ + "img/wp-ranking_en.95024d5.png";